import React, { useState, useEffect } from "react";
import { Card, Row, Col, Form, Button, Input, notification } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import apiService from "../Services/ApiService";
import { sha256 } from "../Services/Crypto";

const InviteV2 = () => {
    const konverseLogoUrl = "https://uploads-ssl.webflow.com/5e960a73ae45f24b7959e93e/5e98af09a264bd68a6f91651_rsz_koverse_logo-p-500.png";
    const [inviteCode, setInviteCode] = useState(null);
    const [isValidInvite, setIsValidInvite] = useState(true);
    const [inviteData, setInviteData] = useState(null);
    const [inviteForm] = Form.useForm();
    const backgroundStyle = {
        backgroundImage: "url(/img/others/img-17.jpg)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
    };
    const history = useHistory();
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();

    const onFinish = (values) => {
        values.password = sha256(values.password);
        values = {
            ...values,
            ...inviteData,
            inviteCode
        }
        console.log("Values", values);

        apiService.post(`/hulk/invite/accept`, {}, values)
			.then((response) => {
				if (response.status != "success") {
					notification.error({
						message: response.message
					});
					return;
				}
                history.push("/home");
			})
			.catch((err) => {
				console.error(err);
				notification.error({
					message: "Unable to load invite"
				});
			});
    }

    const fetchInviteInformation = () => {
        apiService.get(`/hulk/exists/invite_v2/${inviteCode}`)
			.then((response) => {
				if (response.status != "success") {
					notification.error({
						message: response.message
					});
                    setIsValidInvite(false);
					return;
				}
                setInviteData(response.data);
			})
			.catch((err) => {
				console.error(err);
				notification.error({
					message: "Unable to load invite"
				});
                setIsValidInvite(false);
			});
    }


    useEffect(() => {
        if (inviteCode != null) {
            fetchInviteInformation();
        }
    }, [inviteCode]);

    useEffect(() => {
        let code = query.get("ic");

        if (code != null) {
            console.log("Code", code);
            setInviteCode(code);
        }
    }, []);

    return (
        <>
            <div className="auth-container">
                <div className="h-100" style={backgroundStyle}>
                    <div className="container d-flex flex-column justify-content-center h-100">
                        <Row justify="center">
                            <Col xs={20} sm={15} md={10} lg={10}>
                                <Card>
                                    <div className="my-4">
                                        <div className="text-center" style={{marginBottom: "50px"}}>
                                            <img
                                                className="img-fluid h-50 w-50"
                                                src={konverseLogoUrl}
                                                alt=""
                                            />
                                        </div>
                                        <Row justify="center">
                                            <Col xs={24} sm={24} md={20} lg={20}>
                                                <Form onFinish={onFinish} form={inviteForm} >
                                                    <Row gutter={10}>
                                                        <Col span={12}>
                                                            <Form.Item
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "First Name is required"
                                                                    },
                                                                    {
                                                                        max: 35
                                                                    }
                                                                ]}
                                                                name="first_name">
                                                                <Input autoComplete="yes" placeholder="First name" />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Form.Item
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Last Name is required"
                                                                    },
                                                                    {
                                                                        max: 35
                                                                    }
                                                                ]}
                                                                name="last_name">
                                                                <Input autoComplete="off" placeholder="Last name" />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Form.Item
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Password is required"
                                                                    },
                                                                    {
                                                                        max: 20
                                                                    },
                                                                    {
                                                                        pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$/,
                                                                        message: 'Password should have atleast one uppercase alphabet, one special character and one numeric digit. Password length must be greater than or equal to eight and maximum upto 20 characters'
                                                                    }
                                                                ]}
                                                                name="password">
                                                                <Input autoComplete="off" type="password" placeholder="Password" />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Form.Item className="text-center">
                                                                <Button disabled={!isValidInvite} type="primary" htmlType="submit">Accept Invitation</Button>
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </Col>
                                        </Row>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InviteV2;
